//浮点数运算重构，使用示例 a+b => a.add(b)   a-b => a.sub(b)  a*b => a.mul(b)  a/b => a.div(b)
/**浮点数的加运算*/
Number.prototype.add = function (arg) {
  return operation(this, arg, 'add');
};
/**浮点数的减运算*/
Number.prototype.sub = function (arg) {
  return operation(this, arg, 'subtract');
};
/**
 * 浮点数的乘运算
 */
Number.prototype.mul = function (arg) {
  return operation(this, arg, 'multiply');
};
/**浮点数的除运算*/
Number.prototype.div = function (arg) {
  return operation(this, arg, 'divide');
};

function isInteger(obj) {
  return Math.floor(obj) === obj
}
/**将浮点数转为整数，并保存放大的倍数。如0.02 返回2，100 */
function toInteger(floatNum) {
  var ret = {
    floatLength: 1,
    intNum: 0
  };
  if (isInteger(floatNum)) { //如果是整数
    ret.intNum = floatNum;
  } else {
    var strFloat = floatNum + '';
    var dotPosition = strFloat.indexOf('.');
    var len = strFloat.substr(dotPosition + 1).length;
    var floatLength = Math.pow(10, len);
    var intNum = parseInt(Math.abs(floatNum) * floatLength + 0.5, 10); //放大
    ret.floatLength = floatLength;
    if (floatNum < 0) { //负数的处理
      intNum = -intNum;
    }
    ret.intNum = intNum;
  }
  return ret;
}

function operation(a, b, opType) {
  var o1 = toInteger(a);
  var o2 = toInteger(b);
  var int1 = o1.intNum;
  var int2 = o2.intNum;
  var langth1 = o1.floatLength;
  var langth2 = o2.floatLength;
  var maxLength = langth1 > langth2 ? langth1 : langth2; //以最大位数为基准
  var result = null;
  switch (opType) {
    case 'add':
      if (langth1 === langth2) { //两个小数位数相同
        result = int1 + int2;
      } else if (langth1 > langth2) {
        result = int1 + int2 * (langth1 / langth2);
      } else {
        result = int1 * (langth2 / langth1) + int2;
      }
      return result / maxLength;
    case 'subtract':
      if (langth1 === langth2) {
        result = int1 - int2;
      } else if (langth1 > langth2) {
        result = int1 - int2 * (langth1 / langth2);
      } else {
        result = int1 * (langth2 / langth1) - int2;
      }
      return result / maxLength;
    case 'multiply':
      result = (int1 * int2) / (langth1 * langth2);
      return result;
    case 'divide':
      result = (int1 / int2) / (langth1 / langth2);
      return result;
  }
}
//定义remove方法，直接移除某个元素
//*******注意：不要在Array原生上扩展方法
// Array.prototype.remove = function (val) {
//   var index = this.indexOf(val);
//   if (index > -1) {
//     this.splice(index, 1);
//   }
// };

/**
 * 时间加减,传入负数表示减
 */
Date.prototype.addMilliseconds = function (val) {
  return new Date(this.getTime() + val)
}
Date.prototype.addSeconds = function (val) {
  return new Date(this.getTime() + val * 1000)
}
Date.prototype.addMinutes = function (val) {
  return new Date(this.getTime() + val * 60 * 1000)
}
Date.prototype.addHours = function (val) {
  return new Date(new Date(this.getTime()).setHours(this.getHours() + val))
}
Date.prototype.addDays = function (val) {
  return new Date(new Date(this.getTime()).setDate(this.getDate() + val))
}
Date.prototype.addMonths = function (val) {
  return new Date(new Date(this.getTime()).setMonth(this.getMonth() + val))
}
Date.prototype.addYears = function (val) {
  return new Date(new Date(this.getTime()).setFullYear(this.getFullYear() + val))
}
Date.prototype.getWeek = function () {
  var yearFirstDay = new Date(this.getFullYear(), 0, 1);
  var d = Math.round(
    (this.getTime() - yearFirstDay.getTime()) / 86400000
  ) + 1; //今年第几天
  var addDay = 0;
  //把开始的几天算在上一年的周次里
  if (yearFirstDay.getDay() != 1) {
    addDay = 7 - yearFirstDay.getDay() + 1;
  }
  return Math.ceil((d - addDay) / 7);
}
/**
 * 获得本月第一天
 */
Date.prototype.getMonthFirstDay = function () {
  return new Date(new Date(new Date(this.getTime()).setDate(1)).setHours(0, 0, 0, 0));
}
/**
 * 获得本月最后一天
 */
Date.prototype.getMonthLastDay = function () {
  return new Date(new Date(new Date(new Date(this.getTime()).setMonth(this.getMonth() + 1)).setDate(0)).setHours(23, 59, 59, 999));
}
/**
 * 获得当天开始时间
 */
Date.prototype.getDayStart = function () {
  return new Date(new Date(this.getTime()).setHours(0, 0, 0, 0));
}
/**
 * 获得当天结束时间
 */
Date.prototype.getDayEnd = function () {
  return new Date(new Date(this.getTime()).setHours(23, 59, 59, 999));
}
/**
 * 是否为今天
 */
Date.prototype.isToday = function () {
  let t = new Date();
  return this.getFullYear() === t.getFullYear() && this.getMonth() === t.getMonth() && this.getDate() === t.getDate();
}
/**
 * 是否为昨天
 */
Date.prototype.isYestoday = function () {
  let t = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
  return this.getFullYear() === t.getFullYear() && this.getMonth() === t.getMonth() && this.getDate() === t.getDate();
}
/**
 * 是否为明天
 */
Date.prototype.isTomorrow = function () {
  let t = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  return this.getFullYear() === t.getFullYear() && this.getMonth() === t.getMonth() && this.getDate() === t.getDate();
}
/**
 * 是否为同一天
 */
Date.prototype.isSameDate = function (date) {
  let t = new Date(date.getTime());
  return this.getFullYear() === t.getFullYear() && this.getMonth() === t.getMonth() && this.getDate() === t.getDate();
}
/**
 * 是否闰年
 */
Date.prototype.isLeapYear = function () {
  let y = this.getFullYear()
  return ((y % 4 === 0) && (y % 100 !== 0)) || (y % 400 === 0)
}

//JSON.stringify转换日期格式少8小时
Date.prototype.toJSON = function () {
  let date = this;
  let yyyy = date.getFullYear();
  let yy = String(yyyy).slice(-2);

  let M = date.getMonth() + 1;
  let MM = M < 10 ? "0" + M : M;

  let d = date.getDate();
  let dd = d < 10 ? "0" + d : d;

  let H = date.getHours();
  let HH = H < 10 ? "0" + H : H;

  let m = date.getMinutes();
  let mm = m < 10 ? "0" + m : m;

  let s = date.getSeconds();
  let ss = s < 10 ? "0" + s : s;

  let w = date.getDay();
  let arr = ['日', '一', '二', '三', '四', '五', '六'];
  w = arr[w];

  //排序不能变
  const opt = {
    "yyyy": yyyy, // 年
    "yy": yy,
    "MM": MM, // 月
    "M": M, // 月
    "dddd": '星期' + w, // 星期
    "ddd": '周' + w, // 星期
    "dd": dd, // 日
    "d": d, // 月
    "HH": HH, // 时
    "H": H, // 时
    "mm": mm, // 分
    "m": m, // 分
    "ss": ss, // 秒
    "s": s, // 秒
    'w': w, // 星期
  };
  let fmt = "yyyy/MM/dd HH:mm:ss";
  let ret;
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], opt[k])
    };
  };
  return fmt;
}

//Array的扩展方法
zj_array = (function () {
  var array = {
    remove: function (array, item) {
      var index = array.indexOf(item);
      if (index > -1) {
        array.splice(index, 1);
      }
    },
    //移除第几个
    removeAt: function (array, index) {
      var len = array.length;
      if (index >= 0 && index < len) {
        array.splice(index, 1);
      }
    }
  };
  return array;
}());
